import { render, staticRenderFns } from "./BillingLimitBanner.vue?vue&type=template&id=4da20bb1&"
import script from "./BillingLimitBanner.vue?vue&type=script&lang=js&"
export * from "./BillingLimitBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports